module.exports = __webpack_public_path__ + "img/error-config-banner.svg";